// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/TailorDateField/Onchange.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {TailorDateField} from '@sail/ui';

export const Onchange = () => {
  return (
    <TailorDateField
      label="Date of birth"
      description="Enter your birthday"
      onChange={(e) => {
        // eslint-disable-next-line no-console
        console.log(e.target.value);
      }}
    />
  );
};
